import { cn } from "@/lib/utils";

// Reusable glass command panel with technical header + corner accents.
export function Panel({ title, icon: Icon, right, className, bodyClassName, children, testId }) {
  return (
    <div className={cn("jv-panel flex flex-col animate-fade-up", className)} data-testid={testId}>
      {(title || right) && (
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-jarvis-cyan/10 shrink-0">
          <div className="flex items-center gap-2">
            {Icon && <Icon className="w-3.5 h-3.5 text-jarvis-cyan" />}
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-jarvis-cyanBright/90">
              {title}
            </h3>
          </div>
          {right}
        </div>
      )}
      <div className={cn("flex-1 min-h-0 p-4", bodyClassName)}>{children}</div>
    </div>
  );
}

export function StatusDot({ status = "online" }) {
  const map = {
    online: "text-jarvis-green",
    strained: "text-jarvis-amber",
    degraded: "text-jarvis-red",
    offline: "text-jarvis-red",
  };
  return (
    <span
      className={cn("inline-block w-2 h-2 rounded-full jv-pulse", map[status] || "text-jarvis-cyan")}
      style={{ backgroundColor: "currentColor" }}
    />
  );
}
